import React from 'react';

import { IconInCircleWithLabel } from '../../uiComponents/iconInCircleWithLabel/iconInCircleWithLabel.component';
import { CompanyLogo } from '../companyLogo/companyLogo.component';
import { MenuPosition } from '../../interfaces/menu.types';
import { PageType } from '../../enums/pageType.enum';
import { LogoVersion } from '../companyLogo/companyLogo.enums';
import { renderWhenTrueOr, renderInternalLink, renderExternalLink } from '../../utils';
import { LanguageSlug } from '../../enums/languageSlug.enum';

import {
  MenuPositionItem,
  Container,
  MenuContainer,
  MenuPositionsContainer,
  CompanyLogoContainer,
  MenuIconFile,
} from './header.styled';
import { HeaderData } from './header.types';
import { LanguageSwitch } from './components/languageSwitch/languageSwitch.component';

export const Header: React.FC<HeaderData> = (data: HeaderData) => {
  const { languages, menu, logoData, showExpandedMenu, currentLanguage, setCurrentLanguage } = data;
  const linkForLanguageButton = `/${currentLanguage === LanguageSlug.Pl ? '' : currentLanguage}`;

  const renderMenuPositions = () => menu.map((menuPosition: MenuPosition) => {
    const renderLink = renderWhenTrueOr(
      () => renderInternalLink(menuPosition.label, menuPosition.internalPage, currentLanguage),
      () => renderExternalLink(menuPosition.label, menuPosition.externalPage)
    );
    const currentPath = typeof window !== 'undefined' ? window.location.href : '';
    const isActivePosition = currentPath.includes(menuPosition.internalPage?.post_name);

    return (
    <MenuPositionItem key={menuPosition.label} isActive={isActivePosition}>
      {renderLink(menuPosition.positionType === PageType.Internal)}
    </MenuPositionItem>
    );
  });

  return (
    <Container>
      <MenuContainer>
        <IconInCircleWithLabel
          label='menu'
          onClick={() => showExpandedMenu(true)}
        >
          <MenuIconFile />
        </IconInCircleWithLabel>
        <CompanyLogoContainer>
          <CompanyLogo
            target={linkForLanguageButton}
            logoData={logoData}
            version={LogoVersion.WithColor}
          />
        </CompanyLogoContainer>
      </MenuContainer>
      <MenuContainer>
        <MenuPositionsContainer>
          {renderMenuPositions()}
        </MenuPositionsContainer>
        <LanguageSwitch
          languages={languages}
          currentLanguage={currentLanguage}
          setCurrentLanguage={setCurrentLanguage}
        />
      </MenuContainer>
    </Container>
  );
}
